<rav-modal modalId="verify2fa-code" modalTitle="Enter the Verification code">
  <div *ngIf="modalData">
    <p>{{ modalData['message'] }}</p>
    <p *ngIf="expirationTime > 1">The code will expire in {{ expirationTime }} seconds</p>
    <p *ngIf="expirationTime === 1">The code will expire in {{ expirationTime }} second</p>
    <p *ngIf="expirationTime === 0">The code expired</p>

    <div [class.form__error-msg]="errorMessage">
      <input
        type="tel"
        class="padding-horizontal-1"
        [class.is-invalid-input]="errorMessage"
        placeholder="Enter the 6 digit code"
        [(ngModel)]="code"
        (keyup.enter)="code && verifyCode()"
      />
      {{ errorMessage }}
    </div>
    <p>Having trouble receiving the code?</p>
    <p>Please unblock the phone number: 832-730-5095 and <a (click)="resendCode()">Resend Verification Code</a></p>

    <div class="margin-top-1">
      <button type="button" data-cy="cancel-button" (click)="closeModal()" class="hollow button margin-right-1">
        Cancel
      </button>
      <button type="button" [disabled]="!code" (click)="verifyCode()" class="button margin-right-1">
        Done
      </button>
    </div>
  </div>
</rav-modal>
